import { render } from "./ConferenceRoom.vue?vue&type=template&id=72a1ba53"
import script from "./ConferenceRoom.vue?vue&type=script&lang=js"
export * from "./ConferenceRoom.vue?vue&type=script&lang=js"

import "./ConferenceRoom.vue?vue&type=style&index=0&id=72a1ba53&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__